import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../Layout/PrivateLayout';
import * as rsuite from 'rsuite';
import * as General from '../General/General';




const DashboardIndex = () => {


    const GetUserConfig = () => {
        var myHeaders = new Headers()
        myHeaders.append("ApiKey", General.APIKey())

        var requestOptions = {
            headers: myHeaders,
            method: 'Get',
            credentials: 'include'
        }
        // trackPromise(
        fetch(General.ApiRoute() + '/Common/GetUserConfig', requestOptions)
            .then(res => res.json())
            .then(result => {
                for (var i = 0; i < result.length; i++) {
                    localStorage.setItem(result[i].key_ShortCut, result[i].value)
                }
            })
        // )
    }

    useEffect(() => {
        GetUserConfig();
        document.title = "داشبورد ";
    }, [])



    return (

        <Layout title="داشبورد">
            <rsuite.Row>
                <rsuite.Col xs={24} className="text-center mt-30vh Font17 fw-bold">
                    <div>
                        <img src="../../assets/images/Logo.png" style={{ width: 150 }} />
                    </div>
                    <br/>
                    <br/>
                    سیستم جامع حسابداری، انبارداری، فروش، فارم آسان
                </rsuite.Col>
            </rsuite.Row>
        </Layout >

    )
}

export default DashboardIndex;